import { router } from 'expo-router';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H5Emphasized,
    Sheet,
    YStack,
} from 'smoothie';

import { trackView } from '../../logger/Logger';

export const BillsSwitchedSheet = ({
    isOpen,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
}) => {
    if (isOpen) {
        trackView('BillSwitchCompletedSheet');
    }
    return (
        <Sheet isOpen={isOpen} onClose={onClose} showCloseButton={true}>
            <YStack
                flex={1}
                marginTop={16}
                marginHorizontal={8}
                $sm={{ width: 400 }}
            >
                <H5Emphasized textAlign="center">All done!</H5Emphasized>
                <BodyMediumRegular
                    paddingTop={16}
                    paddingBottom={24}
                    color="$gray1000"
                >
                    All bills switched &mdash; nice work! View your full
                    checklist to wrap up the rest of your setup.
                </BodyMediumRegular>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Continue to checklist"
                    onPress={() => {
                        router.navigate('/banking-switch/checklist');
                        onClose();
                    }}
                />
            </YStack>
        </Sheet>
    );
};
